import { isEmpty } from 'lodash';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import helper from 'utils/helpers'

const LastUpdatedOn = ({userDetails}) => {
  const { t } = useTranslation();
  const location = useLocation()
  const [userData, setUserData] = useState(
    !isEmpty(location.state?.userDetails)
    ? location.state?.userDetails
    : userDetails
    );
  return (
    <div>
      <div className=''>
        <table className='w-full text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-lg text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                {t('O_MODULE_NAME')}
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('O_LAST_UPDATED_ON')}
              </th>
            </tr>
          </thead>
          <tbody className='text-sm'>
            <tr>
              <td className='py-3 px-6'>Personal Details</td>
              <td className='py-3 px-6'>{helper.dateFormat(userData?.updatedAt)}</td>
            </tr>
            <tr>
              <td className='py-3 px-6'>User Verified Date</td>
              <td className='py-3 px-6'>{userData?.verificationDate? helper.dateFormat(userData?.verificationDate) : t("O_N/A")}</td>
            </tr>
            <tr>
              <td className='py-3 px-6'>Post</td>
              <td className='py-3 px-6'>{userData?.posts?.length > 0 ? helper.dateFormat(userData?.posts[0]?.createdAt) : t("O_N/A")}</td>
            </tr>
            <tr>
              <td className='py-3 px-6'>Sold Items</td>
              <td className='py-3 px-6'>{userData?.soldItems?.length > 0 ? helper.dateFormat(userData?.soldItems[0]?.createdAt) : t("O_N/A")}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default LastUpdatedOn